module.exports = __webpack_public_path__ + "static/media/img-ipad-dashboard.ea84efd4.jpg";